module.exports = __webpack_public_path__ + "media/images/pages/peel-case/case-3-818565c4488c066a70d5d4db9f6d8c1a.png";